// extracted by mini-css-extract-plugin
export default {"shubhYatra_wrapper":"topSection_shubhYatra_wrapper__UIlFh"};